var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.092 10.1329L13.9984 13.0386L13.0382 13.9987L10.1325 11.0924C9.0514 11.9591 7.70665 12.4305 6.32101 12.4285C2.94987 12.4285 0.213867 9.69252 0.213867 6.32138C0.213867 2.95023 2.94987 0.214233 6.32101 0.214233C9.69215 0.214233 12.4282 2.95023 12.4282 6.32138C12.4301 7.70702 11.9587 9.05177 11.092 10.1329ZM9.73083 9.62941C10.592 8.7438 11.073 7.55667 11.071 6.32138C11.071 3.69666 8.94504 1.57138 6.32101 1.57138C3.6963 1.57138 1.57101 3.69666 1.57101 6.32138C1.57101 8.94541 3.6963 11.0714 6.32101 11.0714C7.5563 11.0733 8.74343 10.5924 9.62904 9.7312L9.73083 9.62941Z",
    fill: "#E72649"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search-active.7225c5797944eb844f6e76f072839b26.svg";
export { ForwardRef as ReactComponent };